import { css, SerializedStyles } from '@emotion/react';

export const useStyles = () => ({
  floatingDiv: css({
    backgroundColor: "white",
    borderRadius: "8px",
    boxShadow: "0 0 5px 1px #d0d0d0",
    overflow: "hidden"
  }),
  floatingDivBarTop: css({
    height: "50px",
    textAlign: "left",
    "& p": {
      fontSize: "16px",
      fontWeight: "bold",
      marginLeft: "15px"
    }
  }),
  floatingDivBarTitle: css({
    textAlign: "left",
    backgroundColor: "#f6891f",
    height: "40px",
    paddingLeft: "15px",
    paddingTop: "10px",
    "& p": {
      fontSize: "15px",
      color: "white",
      margin: "0px"
    }
  }),
  floatingDivBarBottom: css({
    height: "50px"
  }),
  floatingDivContent: css({
    overflow: "auto"
  }),
  floatingDivContentWithTitle: css({
    overflow: "auto"
  }),
  floatingDivContentButton: css({
    height: "50px",
    width: "100%",
    justifyContent: "left",
    color: "#00a7dd",
    textTransform: "capitalize",
    paddingLeft: "30px",
    marginTop: "2px",
    borderRadius: "0",
    "&:hover": {
      color: "#f6891f",
    }
  }),
  floatingDivContentButtonSelected: css({
    backgroundColor: "#00a7dd",
    color: "white",
    "&:hover": {
      backgroundColor: "#8fcff6",
      color: "white",
    }
  })
});
